import type {
  UserActivityAnalytics,
  UserActivityAnalyticsQuery,
  UserActivityLive,
  UserActivitySessionLoadRequest,
  UserActivitySummary,
  UserActivitySummaryQuery,
  UserActivitySessionEntry
} from '@jarvis/platform-ui';
import { apiFetch, readJson } from './client';

function toQueryString(params: Record<string, string | number | boolean | undefined>): string {
  const parts = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`);
  return parts.length === 0 ? '' : `?${parts.join('&')}`;
}

export async function getUserActivityLive(): Promise<UserActivityLive> {
  const res = await apiFetch(`/api/admin/user-activity/live`);
  if (!res.ok) throw new Error(`Failed to load live user activity: ${res.status}`);
  return readJson<UserActivityLive>(res);
}

export async function getUserActivityAnalytics(
  query: UserActivityAnalyticsQuery = {}
): Promise<UserActivityAnalytics> {
  const res = await apiFetch(`/api/admin/user-activity/analytics${toQueryString({ ...query })}`);
  if (!res.ok) throw new Error(`Failed to load user activity analytics: ${res.status}`);
  return readJson<UserActivityAnalytics>(res);
}

export async function getUserActivitySummary(
  query: UserActivitySummaryQuery = {}
): Promise<UserActivitySummary> {
  const res = await apiFetch(`/api/admin/user-activity/summary${toQueryString({ ...query })}`);
  if (!res.ok) throw new Error(`Failed to load user activity summary: ${res.status}`);
  return readJson<UserActivitySummary>(res);
}

export async function listUserActivitySessions(
  opts: UserActivitySessionLoadRequest = {}
): Promise<{ total: number; items: UserActivitySessionEntry[] }> {
  const res = await apiFetch(`/api/admin/user-activity/sessions${toQueryString({ ...opts })}`);
  if (!res.ok) throw new Error(`Failed to list user activity sessions: ${res.status}`);
  return readJson<{ total: number; items: UserActivitySessionEntry[] }>(res);
}
